export default __webpack_public_path__ + "static/media/@caahcristina.72282910.jpg";